<template>
  <b-card border-variant="dark" class="rounded-custom-1 border-custom-2">
    <div class="sign-up-title text-center mb-2">
      Login to {{ workspace.name }}
    </div>
    <b-row class="justify-content-center">
      <b-col sm="12" md="8" lg="8">
        <b-card border-variant="dark" class="rounded-custom-1 border-custom-2">
          <sign-in-form :company-slug="companySlug" :submitting="submitting" :state="state" @submit="onSignIn" />
          <b-row class="align-items-center mt-4 mb-3">
            <b-col><div class="think-line" /></b-col>
            <b-col cols="auto">OR</b-col>
            <b-col><div class="think-line" /></b-col>
          </b-row>
          <b-button :disabled="submitting" variant="outline-secondary" class="w-100" @click="onGoogleLogin">
            <google-icon /> Sign in with Google
          </b-button>
        </b-card>
        <b-row class="justify-content-center mt-4">
          <b-col cols="auto">
            <b-button variant="link" class="btn-link-primary" :to="{ name: 'ConnectToWorkspace' }">
              Return to workspace management
            </b-button>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import { mapGetters } from 'vuex'
import SignInForm from '@/components/forms/SignInForm.vue'
import GoogleIcon from '@/assets/images/google.svg'
import { googleSignInUrl } from '@/helpers/external'

export default {
  name: 'Login',

  computed: {
    ...mapGetters([
      'workspace'
    ])
  },

  data() {
    return {
      companySlug: '',
      state: {},
      submitting: false,
      loading: true
    }
  },

  async mounted() {
    this.companySlug = await this.$store.dispatch('getWorkspaceSlug')
    if (!this.companySlug) {
      this.$router.replace({ name: 'ConnectToWorkspace' })
      return
    }

    this.loading = true
    try {
      await this.$store.dispatch('fetchCompany', this.companySlug)
    } catch {
      this.$router.replace({ name: 'ConnectToWorkspace' })
    } finally {
      this.loading = false
    }
  },

  methods: {
    onSignIn(data) {
      this.submitting = true
      this.$store.dispatch('signIn', data)
        .then(data => {
          this.$router.push({ name: 'Home' })
        })
        .catch(errors => { this.state = errors })
        .finally(() => { this.submitting = false })
    },

    onGoogleLogin() {
      location.href = googleSignInUrl
    }
  },

  components: {
    SignInForm,
    GoogleIcon
  }
}
</script>
